import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Home, Activity, Shield, LogOut } from 'lucide-react';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const NAV = [
    { to: "/", label: "Dashboard", icon: Home },
    { to: "/charts", label: "Charts", icon: Activity },
    { to: "/owner", label: "Owner Panel", icon: Shield, adminOnly: true }
  ];

  return (
    <div className="min-h-screen bg-[#0d1117] text-white flex">
      <div className="hidden md:flex flex-col w-64 bg-[#161b22] border-r border-gray-800">
        <div className="p-4 border-b border-gray-800 text-xl font-bold text-orange-500">
          FireBird Crypto
        </div>
        <nav className="flex-1 p-4 flex flex-col gap-2">
          {NAV.map(item => {
            if (item.adminOnly && (!user || user.role !== 'admin')) return null;
            return (
              <NavLink key={item.to} to={item.to} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-800 text-gray-300">
                <item.icon size={20} /> <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-gray-800">
          <button onClick={handleLogout} className="flex items-center gap-3 text-red-500 p-3 w-full hover:bg-red-500/10 rounded-lg">
            <LogOut size={20} /> <span>Logout</span>
          </button>
        </div>
      </div>

      <div className="flex-1 flex flex-col">
        <header className="h-16 bg-[#161b22] border-b border-gray-800 flex items-center justify-between px-4">
          <div className="text-orange-500 font-bold">FireBird Crypto</div>
        </header>
        <main className="flex-1 p-4 md:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
